import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const SUBURB_INFORMATION_METRICS_AU = [
  {
    groupMetricId: '112',
    metricId: '1194',
    displayName: 'Suburb Information: Area',
    definition: 'The approximate land area of the suburb in square metres.',
  },
  {
    metricId: '1195',
    displayName: 'Suburb Information: Schools Number',
    definition: 'The number of schools that exist within the suburb.',
  },
  {
    metricId: '1196',
    displayName: 'Suburb Information: Childcare Number',
    definition: 'The number of childcare centres that exist within the suburb.',
  },
  {
    metricId: '1197',
    displayName: 'Suburb Information: Parks Number',
    definition: 'The number of parks that exist within the suburb.',
  },
  {
    metricId: '1198',
    displayName: 'Suburb Information: Park Percentage',
    definition: 'The ratio of parks to the total suburb area.',
  },
];

export const SuburbInformationMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Suburb Information',
      data: country === 'au' ? SUBURB_INFORMATION_METRICS_AU : [],
    },
  ];

  if (country === 'nz') return null;

  return (
    <div>
      <Typography
        id="suburb-information-metrics"
        variant="h6"
        fontWeight={600}
        my={0.5}
      >
        Suburb Information Metrics
      </Typography>

      <Typography variant="body2">
        The Suburb Information metrics relate to details of a suburb that
        include the area, number of schools/childcare centres, and the
        information on the number of parks that exist in the suburb.
        <br />
        <b>This data only exists for suburbs (locationTypeId = 8)</b>
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell rowSpan={metric.data.length}>
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
